<app-creating-profile *ngIf="english"></app-creating-profile>
<app-creating-profile-hindi *ngIf="hindi"></app-creating-profile-hindi>